import {
  _deleteArgosV25,
  _getArgosV25,
  _postArgosV25,
  _putArgosV25,
} from './_internal';
import {
  DeleteDataFromSensorPayload,
  DeleteDataFromSensorsPayload,
  GetDataFromSensorPayload,
  GetDataFromSensorsPayload,
  GetSensorDataHistoryPayload,
  ImportCSVApiCallPayload,
  RestoreDataFromSensorPayload,
  SensorData,
  UpdateDataFromSensorPayload,
  UpdateDataFromSensorsPayload,
} from 'types/sensorData';

export const getDataFromSensor = (
  payload: GetDataFromSensorPayload
): Promise<SensorData[]> => {
  const route = `api/sensors/${payload.sensorId}/${payload.position_in_sensor}?time_period=${payload.time_period ? payload.time_period.join(',') : ''}&n_values=${payload.n_values ?? ''}`;
  return _getArgosV25({ route: route });
};

export const getDataFromSensors = (
  payload: GetDataFromSensorsPayload
): Promise<any> => {
  const route = 'api/sensors/data/bulk';
  return _postArgosV25({ route: route, payload });
};

export const updateDataFromSensor = (payload: UpdateDataFromSensorPayload) => {
  const route = `api/sensors/${payload.sensorId}/data/${payload.pk_test}`;
  return _putArgosV25({ route: route, payload: payload });
};

export const updateDataFromSensors = (
  payload: UpdateDataFromSensorsPayload
) => {
  const route = 'api/sensors/data/bulk-update';
  return _putArgosV25({ route: route, payload });
};

export const deleteDataFromSensor = (payload: DeleteDataFromSensorPayload) => {
  const route = `api/sensors/${payload.sensorId}/data/${payload.pk_test}`;
  return _deleteArgosV25({ route: route });
};

export const deleteDataFromSensors = (
  payload: DeleteDataFromSensorsPayload
) => {
  const route = 'api/sensors/data/bulk-delete';
  return _deleteArgosV25({ route: route, payload });
};

export const importCSVApiCall = (payload: ImportCSVApiCallPayload) => {
  const route = 'api/sensors/data/csv-import';
  return _postArgosV25({ route, payload });
};

export const restoreDataFromSensor = (
  payload: RestoreDataFromSensorPayload
) => {
  const route = 'api/sensors/data/bulk-restore';
  return _postArgosV25({ route: route, payload });
};

export const getSensorDataHistory = (
  payload: GetSensorDataHistoryPayload
): Promise<any> => {
  const route = 'api/sensors/data/history';
  return _postArgosV25({ route: route, payload });
};
